// 📁 components/StreetView/StreetViewContent.jsx
import { Loader, ExternalLink } from 'lucide-react';

const StreetViewContent = ({ 
  loading, 
  error, 
  isAvailable, 
  panoramaRef, 
  onOpenInGoogleMaps 
}) => (
  <div className="streetview-content">
    {loading && (
      <div className="streetview-loading" role="status">
        <Loader className="spinner" size={40} />
        <p>Chargement de Street View...</p>
      </div>
    )}

    {error && (
      <div className="streetview-error" role="alert">
        <p>{error}</p>
        {!isAvailable && (
          <p className="streetview-hint">
            Street View n'est peut-être pas disponible à cet endroit exact.
          </p>
        )}
        <button 
          onClick={onOpenInGoogleMaps} 
          className="streetview-fallback-btn"
        >
          <ExternalLink size={16} />
          Ouvrir dans Google Maps
        </button>
      </div>
    )}

    <div
      ref={panoramaRef}
      className="streetview-panorama"
      style={{ display: loading || error ? 'none' : 'block' }}
      role="img"
      aria-label="Vue Street View panoramique"
    />
  </div>
);

export default StreetViewContent;